import React, { Component } from 'react'


class ProjectSixDetails extends Component {
  render(){
  return(

          <div class="text">

          <p><h1>Heli Sivunen</h1> </p>
<p>Full Stack / Front End Developer with TV news background <span role="img" alt="" aria-label="Clapperboard">🎬</span></p>
<p>{`I'm a full stack developer, a recent graduate of the Makers bootcamp in
London and work for Channel 4 News.`}  </p>
<p>{`I'm particularly excited about front end work, especially building beautiful,
user-friendly apps and immersive scrollytelling pages. I love it when
something small I've built elicits reactions of wonder from those I demo it to!
For example, I've recently built and deployed websites with birthday greetings
for friends and family instead of cards - exciting to receive, and great for the
environment too.`}  </p>
<p>{`I want to put my programming skills to use for the benefit of our planet,
and see endless possibilities for this. I'm a tree-hugging vegan, and member of
my company's Sustainability Forum, where we work to reduce carbon footprint.`}  </p>
<p>{`I also want to demystify programming for those who aren't normally
drawn into it as a career, especially girls. I got into programming myself
thanks to a RailsGirls workshop, and have been coding with my daughter on
Sphero Edu and Scratch.`}  </p>
<p>{`Inclusive design fascinates me and I want to become good at it - I knew
the issues but Chimmy Kalu's talk at this year's Women Driven Development
conference was an eye-opener for me.`}  </p>
<h2>Projects</h2>
<p>
<td><strong>Jack The Ripper</strong></td>
<p>{`iOS native Jack the Ripper geolocation game. This was my final project at
Makers,  designed and written in a group of 6.`}</p>
<a href="https://medium.com/@helisivunen">Here's my blog from the two-week project!</a>
<p>{`Tech stack: Swift, Xcode.`}</p>
<span><img src="./images/JackTheRipper.gif" width="180" height="350" alt="Jack The Ripper gif"/></span>
</p>
<p>
<td><strong>Disco</strong></td>
<p>{`Colour-changing app for learning to write React.`}</p>
<p>{`Tech stack: Swift, Xcode`}</p>
<img src="/images/JackTheRipper.gif" width="180" height="350"/>
<a href="https://blooming-waters-22212.herokuapp.com/">https://blooming-waters-22212.herokuapp.com/</a>
<img rc="./images/Disco_1.gif"/>
</p>
<p>
<td><strong>Headline Search</strong></td>
<p>{`API call app for searching FT headlines.`}</p>
<p>{`Tech stack: Ruby, Rails, CSS to emulate FT's colour and font.`}</p>
<img alt="" src="/public/FT.gif"/>
</p>
<p>
<td><strong>Tarvikkeet</strong></td>
<p>{`Finnish-language front end CRUD project to learn CSS and scrollytelling
with still images and video. Tech stack: Ruby, Rails, HTML, CSS.`}</p>
<img alt="" src="./images/Tarvikkeet_small.gif"/>
</p>
<td><strong>Transferable skills</strong></td>

<ul>
<li>Excellent communication skills - I can condense complex information and <br></br>
present it convincingly.</li>
<li>Understanding of user behaviour online (click-throughs)</li>
<li>Logistics, copyright and legal/music clearance</li>
<li>Writing, video editing and editorial skills</li>
<li>Juggling multiple tasks at once and remaining calm under pressure</li>
</ul>
<h2>Experience</h2>
<strong>Channel 4 News, ITN</strong>
<p>Current role:</p>
<ul>
<li>  News Editor: running the newsdesk, which is the nerve centre of<br></br>
the newsroom. I generate story ideas, spot the best picture of the day, assign <br></br>
reporters and camera crews to cover stories and provide editorial and legal <br></br>
guidance.</li>
</ul>
<p>Previous roles:</p>
<ul>
<li>  Site Editor, Channel 4 News Digital: managing a team of <br></br>
journalists working on our digital platforms. I learned about SEO, <br></br>
thumbnails/story promotion, CMS and publishing tools.  </li>
<li>  Producer: making stories into engaging TV.</li>
<li>  Avid Edit Trainer: training more 100+ staff across departments <br></br>
on Avid editing software and server tools, in London and DC</li>
</ul>
<p><strong>CNN International</strong>   </p>
<ul>
<li>  Satellite Feed Producer in the CNN London Master Control Room  </li>
</ul>
<p><strong>Heart 106.2</strong>  </p>
<ul>
<li>  Reporter: interviewing politicians and covering stories from <br></br>
scrabble championships to police raids.</li>
</ul>
<h2>Education</h2>
<h4>Makers Academy</h4>
<ul>
<li><p>12-week, intensive career change bootcamp. First four weeks was <br></br>
Ruby/Rspec, then JavaScript,and for the final project I learned Swift.<br></br>
The course taught me pair programming, TDD, Agile practices, modelling, <br></br>
debugging and clean code. I'm currently taking a top-up React course with <br></br>
Makers, because I want to gain amazing front-end skills.</p>
<h4>Tech learned:</h4>
<ul>
<li>Languages: Ruby, JavaScript, React, HTML, CSS, Swift</li>
<li>Frameworks: Rails, Node.js</li>
<li>Test suites: Jest, React Testing Library, RSpec, Capybara, Travis</li>
<li>IDEs: Atom, Visual Studio, Xcode</li>
<li>Other technologies: GitHub, Heroku, SQL/TablePlus, Azure DevOps</li>
</ul>
</li>
</ul>
<h4>London School of Economics (LSE)</h4>
<ul>
<li>MSc International Relations</li>
</ul>
<h4>Institut Universitaire de Technologie (IUT) Bordeaux</h4>
<ul>
<li>Attended their prestigious journalism school for 3 months</li>
</ul>
<h4>City University, London</h4>
<ul>
<li>BA (Hons) Journalism and Psychology</li>
</ul>
<h4>Spoken languages</h4>
<ul>
<li>Bilingual Finnish / English, fluent French, A-level standard Swedish and German</li>
</ul>
<h2>Interests</h2>
<ul>
<li>I love the TLDR newsletter, which is a perfect tech geek roundup for someone <br></br>
like me, who's juggling many things!</li>
<li>Pod Save America and Campaign HQ are essential listening to enable me to <br></br>
stay on top of the US Presidential election</li>
<li>I'm in the early stages of writing a book and scrollytelling project from <br></br>
more than 2,000 letters my grandparents  sent to each other when my grandfather <br></br>
was fighting in the Finnish Continuation War during WWII.</li>
</ul>
                </div>

    )
  }
}

 export default ProjectSixDetails
